<script>
    import {
        state,
        pending,
        requested,
        atoms,
        molecules,
        contractAddress,
        available,
        claim,
        checkFormula,
        readConfig,
    } from "./stores/contracts";
    import {unlock, unlock_requested, address, wallet_injected} from "./stores/wallet";
    import {interpretConfig} from "./stores/metadata";
    import Loader from "./components/Loader.svelte";
    import {molecules as allMolecules } from "./stores/configs";

    let viewState, transacting = false;

    let mintIndex;

    function openseaLink(_tokenId){
        return "https://opensea.io/assets/"+contractAddress.molecules+"/"+_tokenId;
    }


    // let loadDotsBase = ".....·····˙˙˙˙˙·····";
    // let loadDotsBase = "▒▒▓▓██▓▓▒▒░░";
    // let loadDots = "";
    // let loadNum = 0;
    // setInterval(() => {
    //     loadNum = (loadNum + 1) % loadDotsBase.length;
    //     loadDots = "";
    //     for (let i = 0; i < 5; i++) {
    //         loadDots += loadDotsBase[loadDotsBase.length - 1 - (loadNum + i) % loadDotsBase.length];
    //     }
    //     // loadNum++;
    //     // loadNum %= 5;
    //     // loadDots = "";
    //     // for(let i = 0; i < 5; i++){
    //     //     if(i <= loadNum){
    //     //         loadDots += "_";
    //     //     }else{
    //     //         loadDots += "-";
    //     //     }
    //     // }
    //
    //
    // }, 200);


    $:{
        transacting = $pending || $requested;

        if ($atoms.state === $molecules.state) {
            viewState = $molecules.state;
        } else if ($atoms.state === "error" || $molecules.state === "error") {
            viewState = "error";
        } else {
            viewState = "loading";
        }
    }


    //{
    // atoms: pickAtomsForMolecule(atomicNumbers,tokenIds,_config),
    // configs: _config,
    // formula: _formula,
    // count: 0,
    //}

    async function clickClaim(index) {
        mintIndex = index;
        // console.log(interpretConfig($available[index].configs));
        // console.log($available[index].atoms);
        // console.log($available[index]);
        //
        // // let fixedLength = await readConfig($available[index].configs);
        // console.log(fixedLength);
        // console.log("!!!");
        // let formula = await checkFormula($available[index].configs);

        await claim($available[index].atoms);

        index = null;
    }

    let viewAll = false;

    function toggleViewAll(){
        viewAll = !viewAll;
    }

</script>

<h1><img class="logo" src="./images/logo_long.png" alt="POW NFT MOLECULES"></h1>

<div  class="info"><a target="_blank" href="https://etherscan.io/token/{contractAddress.molecules}">POW NFT Molecules</a> is a project built on top of <a target="_blank" href="https://www.pownft.com">POW NFT</a>. Anyone who owns POW NFT Atoms may mint Molecules, as long as they own the correct combination of Atoms. There's no mint cost apart from gas. There are 512 different Molecules, rarity will be determined by what people choose to mint. The total supply of Molecules may never exceed the total supply of Atoms. Molecule metadata is fully on chain and is represented as the Molecule's chemical formula.</div>

<div class="view-all">
    {#if !viewAll}
        <button on:click={toggleViewAll}>View all possible Molecules</button>
    {:else}
        <button on:click={toggleViewAll}>Return to mint page</button>

    {/if}
</div>

{#if viewAll}
<!--    <div>-->
        {#each allMolecules as {name,config},i}
            <div class="molecule-row">{name}</div>
        {/each}
<!--    </div>-->
{:else}
    {#if $state === "initial"}
        {#if !$wallet_injected}
            <div>This site requires a Web3 enabled browser. </div>
            <div>Please ensure your Web3 wallet is unlocked in order to connect.</div>
        {:else if !$unlock_requested}
            <button on:click={unlock}>Connect Web3 Wallet</button>
        {:else}
            <div>
                <Loader />
            </div>
        {/if}
    {:else if $state === "loading"}
        <div>
            <Loader />
        </div>
    {:else if $state === "loaded"}
        <!--    <div>-->
        <!--        CONNECTED!-->
        <!--    </div>-->
    {:else if $state === "network"}
        <div>Incorrect network. Please connect to Mainnet.</div>
    {:else}
        <div class="error">Web3 wallet error</div>
    {/if}

    {#if $state === "loaded"}
        {#if viewState === "initial" }
            <div><Loader /></div>
        {:else if viewState === "loading"}
            <div><Loader /></div>

        {:else if viewState === "error"}
            <div>Error getting Atom or Molecule data.</div>
        {:else}
            <!--Loaded-->

            {#if $molecules.tokenIds.length > 0}
                <h2>Your Molecules</h2>
                {#each $molecules.tokenIds as tokenId,i}
                    <div class="molecule-row">
                        <a class="yourMolecule" target="_blank" href="{openseaLink(tokenId)}">
                            {$molecules.formulas[i]}
                        </a>
                    </div>
                {/each}
                <div class="vertical">&nbsp;</div>
            {/if}


            {#if $available.length === 0}
                <div>You don't have sufficient Atoms to mint any Molecules.</div>
            {:else}
                <h2>Select Molecule to mint</h2>

                {#each $available  as {atoms,configs,formula,count},i}
                    <div class="molecule-row">
                        {#if transacting}
                            {#if  mintIndex !== i}
                                &nbsp;
                            {:else}
                                &gt; {formula} &nbsp; <Loader size="small"/>
                            {/if}
                        {:else}
                            <button on:click={()=>{clickClaim(i)}}>{formula}</button>

                            {#if count > 0}
                                &nbsp;( owned )
                            {/if}
                        {/if}
                    </div>
                {/each}
            {/if}
        {/if}

    {/if}
{/if}